import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: (name: string) => name ?? translate({ id: 'setup.traffic.unnamedTrafficArea' }),
    description: (name: string) => name ?? translate({ id: 'global.trafficArea' }),
    edit: translate({ id: 'global.edit' }),
    delete: translate({ id: 'global.delete' }),
    exportKML: translate({ id: 'global.exportKML' }),
    defaultDrivingTime: translate({ id: 'setup.traffic.defaultDrivingTimeLabelText' }),
    multipleValues: translate({ id: 'global.multipleValues' }),
    TimeWindowsDrivingTime: translate({ id: 'setup.traffic.timeWindowsDrivingTimeText' }),
  }))

  return api
}
